import * as React from 'react';
const SvgDesignStructure = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.806 98.774V50.387a5.805 5.805 0 0 1 5.807-5.806M116.194 98.774V50.387a5.805 5.805 0 0 0-5.807-5.806M108.452 122H15.548C8.068 122 2 115.932 2 108.452h48.387v3.871h23.226v-3.871H122c0 7.48-6.068 13.548-13.548 13.548ZM91.032 62l9.678 5.806L62 91.032 23.29 67.807 32.968 62M23.29 23.29 62 46.516l38.71-23.226L62 2 23.29 23.29ZM100.71 23.29v44.516"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62 23.29 40.71 34.903V58.13L62 71.677 83.29 58.13V34.903L62 23.29ZM62 46.516v44.516M62 2v9.677M23.29 23.29v44.516"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgDesignStructure;
